import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import Bem from 'bemHelper';
import { emit } from 'helpers/global-events';
import apiDecorator from 'api/api-decorator';
import { reportError } from 'api/api-errors';
import Button, { btnThemes } from 'components/button';
import { iconTypes } from 'components/icon';
import { InputLabel } from 'containers/form';
import Notification from 'components/notification';
import Row, { Col } from 'components/row';
import LayoutContainer, { Stretch, Fixed } from 'components/layout-container';
import ScrollComponent from 'components/scroll-component';

const classesBemForm = new Bem('modalContentAdmin');

@apiDecorator
export default class RemoveThemeContent extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    listBoxItems: PropTypes.arrayOf(PropTypes.shape({})),
    onResetSelection: PropTypes.func
  };

  // Action for closing modal window
  static contextTypes = {
    close: PropTypes.func.isRequired
  };

  constructor(...args) {
    super(...args);
    this.onTopicChange = this.onTopicChange.bind(this);
    this.removeTopics = this.removeTopics.bind(this);
    this.state = {
      chosenTopic: null
    };
  }

  onTopicChange(chosenTopic) {
    this.setState({ chosenTopic });
  }

  /**
   * Remove topics if posts < 5 in DB.
   *
   * @param topics
   */
  removeTopics(topics) {
    this.api.post('action/forum/actions-remove-topics/remove-topics', {
      postData: {
        topics
      }
    })
      .then(data => this.afterMergeTopics(data, topics))
      .catch(error => reportError(error));

    this.setState({
      chosenTopic: null
    });
  }

  // Call after success merge topics.
  afterMergeTopics(data, topics) {
    if (data.canNotRemove.length > 0) {
      Notification.warning(`Следующие темы не могут быть удалены: ${data.canNotRemove.join()}`);
    } else {
      Notification.success('Темы успешно удалены.');
    }

    this.context.close();
    if (typeof this.props.onResetSelection === 'function') this.props.onResetSelection(false, topics);
    if (typeof this.props.onDeletePost === 'function') this.props.onDeletePost();

    // Update topics.
    emit('updateClubTopics');
  }

  render() {
    const { className, listBoxItems } = this.props;
    const { chosenTopic } = this.state;

    return (
      <ScrollComponent {...classesBemForm({ extra: className })}>
        <div {...classesBemForm('flexColumn')}>
          <LayoutContainer>
            <Stretch>
              <Row>
                <Col allPr={0}>
                  <InputLabel
                    {...classesBemForm('label')}
                    schema={{
                      label: 'Будут удалены следующие темы (если в них не более 5 сообщений):'
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col allPr={0} style={{ lineHeight: 1.5 }}>
                  {map(listBoxItems, (item, index) => (
                    <div key={`title-${index}-${item.id}`}>
                      <span {...classesBemForm('text')} children={item.title} />
                    </div>
                  ))}
                </Col>
              </Row>
            </Stretch>
            <Fixed {...classesBemForm('footer')}>
              <Row allAuto allJustifyCFlexEnd {...classesBemForm('btnsContainer')}>
                <Col allPr={0} allPl={20}>
                  <Button
                    onClick={() => this.removeTopics(listBoxItems, chosenTopic)}
                    label="Удалить темы"
                    iconType={iconTypes.delete}
                    theme={btnThemes.red}
                    contentLeft
                    big
                  />
                </Col>
              </Row>
            </Fixed>
          </LayoutContainer>
        </div>
      </ScrollComponent>
    );
  }
}
